import { render, staticRenderFns } from "./SntTagSuggestions.vue?vue&type=template&id=8c3559a2&scoped=true&"
import script from "./SntTagSuggestions.vue?vue&type=script&lang=js&"
export * from "./SntTagSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./SntTagSuggestions.vue?vue&type=style&index=0&id=8c3559a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3559a2",
  null
  
)

export default component.exports